<template>
    <!-- 对接详情 -->
  <div class="DockingDetailsTop">
    <!-- 对接详情的顶部的nav -->
    <DockingDetailsTitle :title1="'首页'" :title2="msg.title" />
    <div class="contentDiv main">
      <el-row class="content">
        <el-col :xs="24" :sm="17" class="contentLeft">
            <img src="../../../../public/static/images/play3.png" alt="">
        </el-col>
        <el-col :xs="24" :sm="7" class="contentRight">
            <!-- 对接详情顶部右侧nav -->
            <DockingDetailsTopLeftHead :title="'相关视频'" />
         
            <!-- 对接详情顶部右侧视频列表 -->
            <DockingDetailsTopLeftMovieList  :videoList="msg.video"/>
        </el-col>

      </el-row>
    </div>
    <!-- logoUrl: "../../../../public/static/images/IDG-logo.png", -->
  </div>
</template>

<script>
import DockingDetailsTitle from "@/components/DockingSystem/Title/DockingDetailsTitle.vue"; //对接详情顶部的nav
import DockingDetailsTopLeftHead from "@/components/DockingSystem/Head/DockingDetailsTopLeftHead.vue"; //对接详情顶部右侧nav
import DockingDetailsTopLeftMovieList from "@/components/DockingSystem/DockingDetails/DockingDetailsTopLeftMovieList.vue"; //对接详情顶部右侧nav

export default {
  props: {
    msg:Object,//项目详情信息
  },
  components: {
    DockingDetailsTitle,DockingDetailsTopLeftHead,DockingDetailsTopLeftMovieList
  },
  data() {
    return {
    };
  },
  created: function () {},
  methods: {},
};
</script>

<style scoped>
@media (max-width: 768px) {

  .content .contentLeft img{
    display: block;
    margin: 0 auto;
    margin-top: 35%;
}
}
.DockingDetailsTop{
    background-color: #1d1d1f;
	opacity: 0.75;
    padding-bottom: 46px;
}
.contentDiv{

}
.content{
     background-color: #333333;
}
.contentLeft{
   min-height: 400px;
}
.contentLeft img{
    display: block;
    margin: 0 auto;
    margin-top: 25%;
}
.contentRight{

}
</style>